import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _get from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/get";
import _inherits from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/text
 */
import Node from "./node";
/**
 * Tree view text node.
 *
 * The constructor of this class shouldn't be used directly. To create new Text instances
 * use the {@link module:engine/view/downcastwriter~DowncastWriter#createText `DowncastWriter#createText()`}
 * method when working on data downcasted from the model or the
 * {@link module:engine/view/upcastwriter~UpcastWriter#createText `UpcastWriter#createText()`}
 * method when working on non-semantic views.
 *
 * @extends module:engine/view/node~Node
 */

var Text = /*#__PURE__*/function (_Node) {
  _inherits(Text, _Node);

  var _super = _createSuper(Text);

  /**
   * Creates a tree view text node.
   *
   * @protected
   * @param {String} data The text's data.
   */
  function Text(data) {
    var _this;

    _classCallCheck(this, Text);

    _this = _super.call(this);
    /**
     * The text content.
     *
     * Setting the data fires the {@link module:engine/view/node~Node#event:change:text change event}.
     *
     * @protected
     * @member {String} module:engine/view/text~Text#_textData
     */

    _this._textData = data;
    return _this;
  }
  /**
   * Checks whether this object is of the given type.
   *
   *		text.is( 'text' ); // -> true
   *		text.is( 'node' ); // -> true
   *		text.is( 'view:text' ); // -> true
   *		text.is( 'view:node' ); // -> true
   *
   *		text.is( 'model:text' ); // -> false
   *		text.is( 'element' ); // -> false
   *		text.is( 'range' ); // -> false
   *
   * {@link module:engine/view/node~Node#is Check the entire list of view objects} which implement the `is()` method.
   *
   * @param {String} type
   * @returns {Boolean}
   */


  _createClass(Text, [{
    key: "is",
    value: function is(type) {
      return type == 'text' || type == 'view:text' || _get(_getPrototypeOf(Text.prototype), "is", this).call(this, type);
    }
    /**
     * The text content.
     *
     * @readonly
     * @type {String}
     */

  }, {
    key: "data",
    get: function get() {
      return this._textData;
    }
    /**
     * This getter is required when using the addition assignment operator on protected property:
     *
     *		const foo = downcastWriter.createText( 'foo' );
     *		const bar = downcastWriter.createText( 'bar' );
     *
     *		foo._data += bar.data;   // executes: `foo._data = foo._data + bar.data`
     *		console.log( foo.data ); // prints: 'foobar'
     *
     * If the protected getter didn't exist, `foo._data` will return `undefined` and result of the merge will be invalid.
     *
     * @protected
     * @type {String}
     */

  }, {
    key: "_data",
    get: function get() {
      return this.data;
    }
    /**
     * Sets data and fires the {@link module:engine/view/node~Node#event:change:text change event}.
     *
     * @protected
     * @fires change:text
     * @param {String} data New data for the text node.
     */
    ,
    set: function set(data) {
      this._fireChange('text', this);

      this._textData = data;
    }
    /**
     * Checks if this text node is similar to other text node.
     * Both nodes should have the same data to be considered as similar.
     *
     * @param {module:engine/view/text~Text} otherNode Node to check if it is same as this node.
     * @returns {Boolean}
     */

  }, {
    key: "isSimilar",
    value: function isSimilar(otherNode) {
      if (!(otherNode instanceof Text)) {
        return false;
      }

      return this === otherNode || this.data === otherNode.data;
    }
    /**
     * Clones this node.
     *
     * @protected
     * @returns {module:engine/view/text~Text} Text node that is a clone of this node.
     */

  }, {
    key: "_clone",
    value: function _clone() {
      return new Text(this.data);
    } // @if CK_DEBUG_ENGINE // toString() {
    // @if CK_DEBUG_ENGINE // 	return `#${ this.data }`;
    // @if CK_DEBUG_ENGINE // }
    // @if CK_DEBUG_ENGINE // log() {
    // @if CK_DEBUG_ENGINE // 	console.log( 'ViewText: ' + this );
    // @if CK_DEBUG_ENGINE // }
    // @if CK_DEBUG_ENGINE // logExtended() {
    // @if CK_DEBUG_ENGINE // 	console.log( 'ViewText: ' + this );
    // @if CK_DEBUG_ENGINE // }

  }]);

  return Text;
}(Node);

export { Text as default };